import React from 'react';
import { AlertCircle, X, Trash2 } from 'lucide-react';

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  isDestructive?: boolean;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  isDestructive = true
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-6 bg-slate-900/60 backdrop-blur-md animate-in fade-in duration-300">
      <div className="bg-white rounded-[2.5rem] w-full max-w-sm shadow-2xl border border-slate-100 overflow-hidden animate-in zoom-in duration-200">
        <div className="p-8 text-center">
          <div className={`w-16 h-16 ${isDestructive ? 'bg-red-50 text-red-500' : 'bg-violet-50 text-violet-500'} rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-sm`}>
            {isDestructive ? <Trash2 size={32} /> : <AlertCircle size={32} />}
          </div>
          <h3 className="text-xl font-black text-slate-900 tracking-tight mb-2">{title}</h3>
          <p className="text-slate-500 font-bold text-sm leading-relaxed">{message}</p>
        </div>
        
        <div className="p-6 bg-slate-50/50 flex gap-3">
          <button 
            onClick={onClose}
            className="flex-1 py-4 px-6 rounded-2xl bg-white border border-slate-200 font-black text-[10px] uppercase tracking-widest text-slate-400 hover:bg-slate-50 hover:text-slate-600 transition-all shadow-sm"
          >
            {cancelLabel}
          </button>
          <button 
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className={`flex-1 py-4 px-6 rounded-2xl font-black text-[10px] uppercase tracking-widest text-white shadow-lg transition-all transform active:scale-95 ${isDestructive ? 'bg-red-500 hover:bg-red-600 shadow-red-200' : 'bg-slate-900 hover:bg-violet-600 shadow-slate-200'}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};